module.exports = __webpack_public_path__ + "img/logo.e9e5788a.png";